import { Switch as SwitchPrimitive } from "radix-ui";
import { useId } from "react";
import { cn } from "~/foundation/utils/cn";

export interface SwitchProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  label: string;
  description?: string;
  disabled?: boolean;
}

/** Label-first row: the whole row is the control, which is what settings pages want. */
export function Switch({ checked, onCheckedChange, label, description, disabled }: SwitchProps) {
  const id = useId();

  return (
    <div className="flex items-start justify-between gap-4 py-3">
      <div className="min-w-0">
        <label htmlFor={id} className="text-body text-text">
          {label}
        </label>
        {description ? (
          <p className="mt-0.5 text-small text-text-secondary">{description}</p>
        ) : null}
      </div>
      <SwitchPrimitive.Root
        id={id}
        checked={checked}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
        className={cn(
          "relative h-5 w-9 shrink-0 cursor-pointer rounded-full transition-colors duration-100",
          "data-[state=checked]:bg-accent data-[state=unchecked]:bg-bg-tertiary",
          "disabled:cursor-not-allowed disabled:opacity-50",
        )}
      >
        <SwitchPrimitive.Thumb
          className={cn(
            "block size-4 rounded-full bg-bg shadow-sm transition-transform duration-100",
            "translate-x-0.5 data-[state=checked]:translate-x-[18px]",
            "rtl:-translate-x-0.5 rtl:data-[state=checked]:-translate-x-[18px]",
          )}
        />
      </SwitchPrimitive.Root>
    </div>
  );
}
